'use strict'

import '../scss/main.scss'

window.$ = window.jQuery = require('jquery');

import 'bootstrap';

// Image lazy loading
window.lozad = require('lozad');

// Mouse wheel
//require('jquery-mousewheel')($);

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

if (document.querySelector('.mini-slider')) {
  new Swiper('.mini-slider', {
    direction: 'horizontal',
    loop: false,
    speed: 300,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      
    },
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-prod-next',
      prevEl: '.swiper-prod-prev',
    },
    pagination: {
      el: ".swiper-prod-pagination",
      clickable: true,
    },
  });
}

if (document.querySelector('.carousel')) {
  new Swiper('.carousel', {
    direction: 'horizontal',
    loop: false,
    speed: 300,
    slidesPerView: 1,
    spaceBetween: 50,
    breakpoints: {
      450: {
        slidesPerView: 2,
      },
      600: {
        slidesPerView: 3,
      },
      850: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 4,
      },
      
    },
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-mini-next',
      prevEl: '.swiper-mini-prev',
    },
    pagination: {
      el: ".swiper-mini-pagination",
      clickable: true,
    },
  });
}

window.designamite = {

  init()
  {

    designamite.global.init()
    
    designamite.cookie.init()

  },

  global: require('./methods/global'),
  
  cookie: require('./methods/cookie-bar'),
  
}

designamite.init()